
<mat-divider></mat-divider>
<div class="info">
  {{'activation.documents.info' | translate}}
</div>

<div class="button-container"> 
  <div *ngIf="contractID" class="button-wrapper">
    <button class="button" [disabled]="!contractID" (click)="previewDocument(contractID)" [title]="checkDocumentLabel">
      {{ 'activation.documents.contract' | translate }}
    </button> 
  </div>
  <div *ngIf="requestID" class="button-wrapper">
    <button class="button" [disabled]="!requestID" (click)="previewDocument(requestID)" [title]="checkDocumentLabel">
      {{ 'activation.documents.request' | translate }}
    </button> 
  </div>
  <div *ngIf="pppID" class="button-wrapper">
    <button class="button" [disabled]="!pppID" (click)="previewDocument(pppID)" [title]="checkDocumentLabel">
      {{ 'activation.documents.ppprotocol' | translate }}
    </button> 
  </div>
  <div *ngIf="btrustMailActive" class="button-wrapper" >
    
    <button class="button" (click)="previewBtrustMailDocument(serviceRequestId)" [title]="checkDocumentLabel">
      {{ 'activation.documents.btrustMail' | translate }}
    </button> 
  </div>
</div>
<mat-divider></mat-divider>
<div class="button-row" *ngIf="!alreadySigned">
  <button class="navButton" [disabled]="isLoading" (click)="activateCertificate()">
    {{ 'activation.documents.sign' | translate }}
  </button>
</div>
